<template lang="pug">
  el-card.box(shadow="hover")
    h1 Remetentes do WhatsApp
    div.containerBotao
      span Remetentes registrados
      el-button.botaoAdd(type="primary", icon="el-icon-plus", id='botao-add', @click="registrarCliente") Registrar remetente
    div.modulosContainer
      div.modulo(v-for="cliente in clientes" :key="cliente.clientId")
        el-row(type="flex", justify="space-between").nomeModuloContainer
          span.titulo
            h3 {{ encurtarString(cliente.clientId.length, 15, cliente.clientId) }}
          el-dropdown(trigger="click")
            el-col(:span="2")
              i.fa.fa-ellipsis-v(:style="{'font-size': '22px','cursor': 'pointer'}")
              template#dropdown
                el-dropdown-menu
                  el-dropdown-item
                    span(@click="desconectarCliente(cliente.clientId)").moduloAcao
                      i.far.fa-power-off(:style="{'font-size': '20px', 'margin-right': '8px'}")
                      p Desconectar
        .linha
        div.infoModulos
          p
            strong.dado Remetente ID:
            span {{ encurtarString(cliente.clientId.length, 15, cliente.clientId) }}
          p
            strong.dado Status:
            span {{cliente.qrCode ? 'Pendente' : 'Ativo'}}
        div.qrCodeContainer
          el-image(v-if="cliente.qrCode" :src="cliente.qrCode" fit="contain" :style="{'width': '200px', 'height': '200px'}")
          div(v-else).conatinerClienteConectado
            span Remetente conectado!
        div.row-center(v-if="cliente.qrCode")
          strong Leia o QR code para conectar seu dispositivo
    div.formOptionContainer
      el-radio-group(v-model="selectedAction")
        el-radio-button(label="Disparar mensagem individual")
        el-radio-button(label="Criar disparo em massa")

    div.messageFormContainer(v-if="selectedAction === 'Disparar mensagem individual'")
      el-form(ref="messageForm", :model="messageForm", :rules="rules" label-width="120px" label-position="top")
        el-row(:gutter="20")
          el-col(:span="12")
            el-form-item(label="Selecione o remetente" prop="clientId")
              el-select(v-model="messageForm.clientId" placeholder="Selecione um cliente")
                el-option(v-for="cliente in clientesConectados" :key="cliente.clientId" :label="cliente.clientId" :value="cliente.clientId")
          el-col(:span="12")
            el-form-item(label="Número" prop="numero")
              el-input(
                v-model="messageForm.numero"
                placeholder="Insira o número do destinatário"
                v-mask="['+## (##) ####-####', '+## (##) #####-####']"
              )
        el-form-item(label="Mensagem" prop="mensagem")
          el-input(type="textarea", v-model="messageForm.mensagem", :rows="5" placeholder="Insira a mensagem")
        el-form-item
          el-button(type="primary", @click="enviarMensagem") Enviar Mensagem

    div.uploadContainer(v-if="selectedAction === 'Criar disparo em massa'")
      div.statusContainer
        el-row(:gutter="20")
          el-col(:span="8")
            el-card.totalCard(shadow="hover")
              p Total de Mensagens: {{statusDisparo.totalPendente + statusDisparo.totalDisparado}}
          el-col(:span="8")
            el-card.pendenteCard(shadow="hover")
              p Total Pendente: {{statusDisparo.totalPendente}}
          el-col(:span="8")
            el-card.disparadoCard(shadow="hover")
              p Total Disparado: {{statusDisparo.totalDisparado}}

      el-form(ref="massMessageForm", :model="massMessageForm" :rules="massRules" label-width="120px" label-position="top")
        el-form-item(label="Mensagem" prop="massMensagem")
          el-input(type="textarea", v-model="massMessageForm.massMensagem", :rows="5", maxlength="500" placeholder="Insira a mensagem (máx. 500 caracteres)")
          small caracteres {{massMessageForm.massMensagem.length}}/500
          br
          small.text-muted
            | Utilize as seguintes variáveis para personalizar a mensagem:
            br
            | {{variavis[0].nome}} -> substitui o número do processo
            br
            | {{variavis[1].nome}} -> substitui o nome do interessado
        el-form-item(label="Selecione o arquivo com os números de processos" prop="file")
          app-upload-area(
            id="lote",
            :target="'publico/upload'"
            :fileType="validExtensions"
            :onSuccess="onSuccess"
            :documento="file"
            :hasDownloadButton="false",
            v-model="file"
            @removerDocumento="removerDocumento"
            :key="uploadFileComponentKey"
          )
        el-form-item
          span Selecione o arquivo de imagem
          app-upload-area(
            id="imagem-whatsapp",
            :target="'publico/upload'"
            :fileType="validExtensionsImagem"
            :onSuccess="onSuccessImagem"
            :documento="imagem"
            :hasDownloadButton="false",
            v-model="imagem"
            @removerDocumento="removerImagem"
            :maxSize="4"
          )

        el-form-item
          el-button(type="primary", @click="criarDisparoMassa") Criar Disparo em Massa
</template>

<script>
import { registerClient, getClients, disconnectClient, sendMessage, programarMensagens, getStatusDisparo } from '../../../utils/manutencao'
import AppNotificacao from '@/components/mixins/AppNotificacao.vue'
import AppUploadArea from '@/components/AppUploadArea'

export default {
  components: {
    AppUploadArea
  },
  data () {
    return {
      clientes: [],
      statusDisparo: {
        totalPendente: 0,
        totalDisparado: 0
      },
      variavis: [
        { nome: '{{numero_processo}}', descricao: 'Número do processo' },
        { nome: '{{nome_interessado}}', descricao: 'Nome do interessado' }
      ],
      selectedAction: 'Disparar mensagem individual',
      validExtensions: ['xlsx', 'xls', 'csv'],
      validExtensionsImagem: ['jpg', 'jpeg', 'png'],
      file: null,
      imagem: null,
      messageForm: {
        clientId: '',
        numero: '+55',
        mensagem: ''
      },
      massMessageForm: {
        massMensagem: '',
        file: null
      },
      rules: {
        clientId: [{ required: true, message: 'Selecione um cliente', trigger: 'change' }],
        numero: [{
          required: true,
          message: 'Insira o número do destinatário',
          validator: (rule, value, callback) => {
            const telefoneRegex = /^\+\d{2} \(\d{2}\) \d{4,5}-\d{4}$/
            if (!value) {
              rule.message = 'Insira o número do destinatário'
              callback(new Error('Insira o número do destinatário'))
            } else if (!telefoneRegex.test(value)) {
              rule.message = 'Formato de telefone inválido'
              callback(new Error('Formato de telefone inválido'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }],
        mensagem: [{ required: true, message: 'Insira a mensagem', trigger: 'blur' }]
      },
      massRules: {
        massMensagem: [{ required: true, message: 'Insira a mensagem', trigger: 'blur' }],
        file: [{
          required: true,
          message: 'Insira o arquivo',
          trigger: 'change',
          validator: (rule, value, callback) => {
            if (value) {
              callback()
            } else {
              callback(new Error('Insira o arquivo'))
            }
          }
        }]
      },
      uploadFileComponentKey: 0
    }
  },
  async created () {
    await this.buscarTodosClientes()
    await this.atualizarStatusDisparo()
    setInterval(this.buscarTodosClientes, 10000)
    setInterval(this.atualizarStatusDisparo, 10000)
  },
  mixins: [AppNotificacao],
  computed: {
    clientesConectados () {
      return this.clientes.filter(cliente => cliente.qrCode === null)
    }
  },
  methods: {
    async atualizarStatusDisparo () {
      try {
        const status = await getStatusDisparo()
        this.statusDisparo.totalPendente = status.totalPendente
        this.statusDisparo.totalDisparado = status.totalDisparado
      } catch (e) {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao buscar status de disparo')
      }
    },
    onSuccess (id, resumableFile, fileKey) {
      this.massMessageForm.file = {
        fileKey: fileKey,
        nomeOriginal: resumableFile.fileName,
        tamanho: resumableFile.size
      }
    },

    onSuccessImagem (id, resumableFile, fileKey) {
      this.imagem = {
        fileKey: fileKey,
        nomeOriginal: resumableFile.fileName,
        tamanho: resumableFile.size
      }
    },

    removerDocumento () {
      this.massMessageForm.file = null
      this.file = null
      this.uploadFileComponentKey += 1
    },

    removerImagem () {
      this.imagem = null
    },

    async buscarTodosClientes () {
      try {
        const resposta = await getClients()
        this.clientes = resposta
      } catch (e) {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao buscar clientes')
      }
    },
    async registrarCliente () {
      try {
        const resposta = await registerClient()
        if (resposta) {
          this.buscarTodosClientes()
          this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Cliente registrado com sucesso')
        }
      } catch (e) {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao registrar cliente')
      }
    },
    async desconectarCliente (clientId) {
      this.confirmBox('Deseja realmente desconectar este remetente?', 'Atenção',
        async () => {
          try {
            await disconnectClient(clientId)
            this.clientes = this.clientes.filter(cliente => cliente.clientId !== clientId)
            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Cliente desconectado com sucesso')
          } catch (e) {
            this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao desconectar cliente')
          }
        }
      )
    },
    async enviarMensagem () {
      this.$refs.messageForm.validate(async (valid) => {
        if (valid) {
          try {
            const numeroLimpo = this.messageForm.numero.replace(/\D/g, '')
            await sendMessage(numeroLimpo, this.messageForm.mensagem, this.messageForm.clientId)
            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Mensagem enviada com sucesso')
            this.messageForm.numero = '+55'
            this.messageForm.mensagem = ''
          } catch (e) {
            this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao enviar mensagem')
          }
        } else {
          console.log('Erro na validação do formulário')
          return false
        }
      })
    },
    async criarDisparoMassa () {
      this.$refs.massMessageForm.validate(async (valid) => {
        if (valid) {
          try {
            const data = await programarMensagens({ template: this.massMessageForm.massMensagem, key: this.massMessageForm.file.fileKey, keyImagem: this.imagem?.fileKey })
            if (data) {
              this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Disparo em massa criado com sucesso')
              this.massMessageForm.massMensagem = ''
              this.removerDocumento()
              this.removerImagem()
              this.atualizarStatusDisparo()
            }
          } catch (e) {
            this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao criar disparo em massa')
          }
        } else {
          console.log('Erro na validação do formulário')
          return false
        }
      })
    },
    encurtarString (tamanho, limite, texto) {
      return tamanho >= limite ? texto.substring(0, limite) + '...' : texto
    }
  }
}
</script>

<style scoped>
  .box {
    min-width: 700px;
    padding-left: 3px;
    padding-right: 3px;
  }
  .nomeModuloContainer {
    height: 35px;
    align-items: center;
  }
  .infoModulos {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    margin-top: 10px;
  }
  .botao {
    width: 120px;
    height: 40px;
    font-size: 15px;
  }
  .botaoModulo {
    display: flex;
    justify-content: space-between;
  }
  .botaoAdd {
    font-size: 18px;
    align-items: end;
  }
  .containerBotao {
    display: flex;
    justify-content: space-between;
    margin-bottom: 50px;
  }
  .modulosContainer {
    display: flex;
    flex-wrap: wrap;
    justify-content: left;
    align-items: center;
  }
  .modulo {
    border: 1px solid rgba(0, 0, 0, 0.10);
    box-shadow: rgba(0, 0, 0, 0.15) 0px 3px 3px 0px;
    border-radius: 5px;
    width: 380px;
    height: 350px;
    padding: 10px;
    margin: 0px 60px 60px 0px;
  }
  .vistoPorUltimo {
    text-align: start;
    font-size: 10px
  }
  p {
    font-size: 15px ;
    margin-right: 1px;
  }

  .dado {
    margin-right: 5px;
  }

  .titulo {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0;
  }
  .moduloAcao {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 32px;
    width: 110px;
    margin: 0;
  }
  .linha {
    background-color: rgba(0, 0, 0, 0.10);
    margin-top: 10px;
    margin-bottom: 2px;
    width: 100%;
    height: 2px;
  }
  .qrCodeContainer {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .conatinerClienteConectado {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    width: 200px;
    background-color: #ffffff; /* Fundo branco */
    border-radius: 5px;
    border: 2px solid rgb(86, 242, 86); /* Borda verde neon */
    color: rgb(86, 242, 86); /* Texto verde neon */
    font-weight: bold;
  }
  .messageFormContainer {
    margin-top: 50px;
    padding: 20px;
    border-top: 1px solid rgba(0, 0, 0, 0.10);
  }
  .formOptionContainer {
    margin-top: 20px;
    margin-bottom: 40px;
  }
  .statusContainer {
    margin-bottom: 20px;
  }
  .totalCard, .pendenteCard, .disparadoCard {
    text-align: center;
    padding: 10px;
    font-size: 18px;
    font-weight: bold;
  }
  .row-center {
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/screens/manutencao/ma/WapClientsMa.vue